import { Controls } from '../../Controls'

function ComponentProps({ name, ...controlsProps }) {
  return <Controls {...controlsProps} header={`${name} props`} />
}

export default ComponentProps
